$(document).ready(function () {
  
  var counters = document.querySelectorAll('span.nbr'),     // numbers
      len =  counters.length,                                   // numbers quantity
      duration = 1500;                                          // Animation in ms

  // Custom easing function
  $.extend($.easing, {
    // This is ripped directly from the jQuery easing plugin (easeOutExpo), from: http://gsgd.co.uk/sandbox/jquery/easing/
    easing: function (x, t, b, c, d) {
      return (t === d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }
  });
    
  // Function that changes opacity of numbers to 0
  function opacity() {
    var i;

    
  }
    
  // Animation
  function animate() {
    var x, number;

    if (len !== 0) {
      len -= 1;
    }

    x = counters[len];
    number = 'number' + len ;

    // Opacity
    $(counters[len]).animate({opacity : 1}, {
      duration: duration,
      fade: true,
      easing: 'linear'
    });

    // Numbers
    $({number: counters[len].getAttribute('data-from')}).animate({number: counters[len].getAttribute('data-to')}, {
      duration: duration,
      easing: 'easing',
      fade: true,
      queue: false,
      step: function (a) {
        a = Math.round(a);                                      //the value of a number rounded
        a = String(a);                                          //convert a number to a string
        a = a.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');    //thousands separator

        $(x).html(a);
      }
    });
  }

  function showAnimation() {
    opacity();

    var i;

    // Start the animation function
    for (i = 0; i < 6; i += 1) {
      animate(i);
    }
  }
  
  showAnimation();
  
});